<template>
  <el-dialog
    v-bind="$attrs"
    class="confirm-delete-dialog"
    :visible="visible"
    :show-close="false"
    center
    append-to-body
    v-on="$listeners"
  >
    <div class="flex justify-center mb-4">
      <img :src="require('@/assets/images/warning-icon.svg')" alt="" class="warning-icon" />
    </div>
    <slot name="title">
      <div class="font-medium text-lg text-center whitespace-pre-line">
        {{ getTitleText }}
      </div>
    </slot>
    <slot name="description">
      <div v-if="description" class="text-center mt-4 whitespace-pre-line">
        {{ description }}
      </div>
    </slot>
    <slot name="action">
      <div class="flex flex-col items-center lg:flex-row justify-center mt-5 lg:mt-10 lg:mb-4">
        <el-button
          type="danger"
          class="submit-btn bg-red text-normal leading-none lg:ml-6 lg:order-1"
          @click="yesHandler"
        >
          {{ getYesButtonText }}
        </el-button>
        <el-button
          class="
            cancel-btn
            mt-5
            mb-1
            lg:my-0
            border-red
            text-red text-normal
            leading-none
            hover:border-red hover:text-red
          "
          @click="noHandler"
          >{{ $t('common.action.cancel') }}</el-button
        >
      </div>
    </slot>
  </el-dialog>
</template>

<script>
import { nullish } from '@/utils'
export default {
  props: {
    visible: { type: Boolean, default: () => false },
    title: {
      type: String,
      required: false,
      default: () => undefined,
    },
    description: {
      type: String,
      required: false,
      default: () => undefined,
    },
    yesHandler: { type: Function, default: () => {} },
    noHandler: { type: Function, default: () => {} },
    yesButtonText: {
      type: String,
      required: false,
      default: () => undefined,
    },
    noButtonText: {
      type: String,
      required: false,
      default: () => undefined,
    },
  },
  computed: {
    getTitleText() {
      return nullish(this.title, this.$t('common.confirmDeleteDialogTitle'))
    },
    getYesButtonText() {
      return nullish(this.yesButtonText, this.$t('common.action.delete'))
    },
    getNoButtonText() {
      return nullish(this.noButtonText, this.$t('common.action.close'))
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/confirm-delete-dialog.scss';
</style>
